if (!customElements.get("product-card")) {
  class a extends HTMLElement {
    constructor() {
      (super(),
        (this.selectors = {
          images: this.querySelectorAll(
            ".product-card__media-gallery .media:not(.media--alter):not(.media--alter-variant)",
          ),
          swatches: this.querySelector(".product-card__swatches"),
          media_link: this.querySelector(".product-card__media"),
          alters: this.querySelectorAll(".media--alter-variant"),
          default_alter: this.querySelector(".media--alter"),
          gallery_images: this.querySelectorAll(
            ".product-card__media-gallery .media",
          ),
          gallery_prev: this.querySelector(".product-card__gallery-button--prev"),
          gallery_next: this.querySelector(".product-card__gallery-button--next"),
        }),
        (this.current_variant_value = null),
        (this.gallery_index = 0),
        (this.gallery_user_interacted = !1),
        (this.gallery_touch_start = null),
        (this.gallery_pointer_start = null),
        (this.gallery_suppress_click = !1),
        (this.gallery_animating = !1),
        (this.gallery_direction = 1),
        (this.default_alter = this.selectors.default_alter),
        (this.initial_option_value = this.normalizeValue(this.dataset.initialOption)),
        (this.filter_color_value = this.getFilterColorValue()),
        (this.variant_filter_active = !!this.filter_color_value),
        this.isListingGalleryEnabled() && this.initGalleryControls(),
        this.initSwatches());
    }
    normalizeValue(t) {
      return ("" + (t || "")).trim().toLowerCase();
    }
    isRenderedSwatchValue(value) {
      if (!this.selectors.swatches || !value) return false;
      const normalized = this.normalizeValue(value);
      return Array.from(
        this.selectors.swatches.querySelectorAll(".swatch"),
      ).some((swatch) => this.normalizeValue(swatch.dataset.id) === normalized);
    }
    isMobileGallery() {
      return window.matchMedia("(max-width: 767px)").matches;
    }
    isListingGalleryEnabled() {
      return (
        !!this.closest(".listing__grid") &&
        !this.closest(".listing--search") &&
        !this.closest("product-carousel, .product-carousel, .product--carousel")
      );
    }
    isFirstListingProductCard() {
      const grid = this.closest(".listing__grid");
      return !!grid && grid.querySelector("product-card") === this;
    }
    getFilterColorValue() {
      var t = new URLSearchParams(window.location.search).get(
        "filter.v.m.custom.color",
      );
      return t ? this.normalizeValue(t) : null;
    }
    getVariantValueFromUrl() {
      var t,
        a = this.querySelector(".product-card__media");
      if (a && this.dataset.variantMap) {
        let e = null;
        try {
          var i = (a.href || a.getAttribute("href") || "").replace(
              /&amp;/g,
              "&",
            ),
            s = new URL(i, window.location.origin);
          e = s.searchParams.get("variant");
        } catch (t) {
          e = null;
        }
        if (e)
          for (t of this.dataset.variantMap.split("||"))
            if (t) {
              var r = t.split("::");
              if (r[0] === e) {
                const vals = r[1].split(";");
                for (const val of vals) {
                  if (this.isRenderedSwatchValue(val)) return this.normalizeValue(val);
                }
                return this.normalizeValue(vals[0]);
              }
            }
      }
      return null;
    }
    setSwatchImages(a) {
      let i = !1;
      ((this.gallery_index = 0),
        this.gallery_animating = !1,
        this.selectors.alters.forEach((t) => {
          t.style.opacity = "0";
          t.style.transform = "";
          t.style.transition = "";
          t.style.zIndex = "";
        }),
        this.classList.remove("product-card--gallery-active"));
      (this.selectors.images.forEach((t, e) => {
        ((t.style.transform = ""), (t.style.transition = ""), (t.style.zIndex = ""));
        a && this.normalizeValue(t.dataset.id) === a
          ? ((t.style.opacity = "1"), (i = !0))
          : (t.style.opacity = "0");
      }),
        i ||
          this.selectors.images.forEach((t, e) => {
            0 === e && (t.style.opacity = "1");
          }));
      this.updateGalleryControls();
    }
    getSwatchIdForFilterColor() {
      var t;
      return this.filter_color_value &&
        this.selectors.swatches &&
        this.selectors.swatches.querySelector("[data-color-name]") &&
        (t = Array.from(
          this.selectors.swatches.querySelectorAll(".swatch"),
        ).find(
          (t) =>
            this.normalizeValue(t.dataset.colorName) ===
            this.filter_color_value,
        ))
        ? this.normalizeValue(t.dataset.id)
        : null;
    }
    applyVariantImage() {
      let t = null;
      if (this.variant_filter_active) {
        t =
          this.getSwatchIdForFilterColor() ||
          this.initial_option_value ||
          this.getVariantValueFromUrl();
      } else if (this.initial_option_value) {
        t = this.initial_option_value;
      }
      if (t) {
        this.current_variant_value = t;
        this.setSwatchImages(this.current_variant_value);
      } else if (this.variant_filter_active) {
        this.selectors.images.forEach((t, e) => {
          t.style.opacity = 0 == e ? "1" : "0";
        });
      }
      this.updateGalleryControls();
    }
    getActiveGalleryItems() {
      const items = Array.from(this.selectors.gallery_images || []);
      if (items.length < 2) return items;
      const value = this.current_variant_value;
      if (value) {
        const variantItems = items.filter(
          (item) => this.normalizeValue(item.dataset.id) === value,
        );
        if (variantItems.length > 1) return variantItems;
      }
      const activeItem = items.find((item) => item.style.opacity === "1");
      const activeId = activeItem && activeItem.dataset.id;
      if (activeId) {
        const activeGroup = items.filter((item) => item.dataset.id === activeId);
        if (activeGroup.length > 1) return activeGroup;
      }
      const firstId = items[0] && items[0].dataset.id;
      if (firstId) {
        const firstGroup = items.filter((item) => item.dataset.id === firstId);
        if (firstGroup.length > 1) return firstGroup;
      }
      return items;
    }
    setGalleryIndex(index, items) {
      const galleryItems = items || this.getActiveGalleryItems();
      if (galleryItems.length < 2 || this.gallery_animating) return;
      const nextIndex = (index + galleryItems.length) % galleryItems.length;
      const currentItem =
        galleryItems[this.gallery_index] ||
        galleryItems.find((item) => item.style.opacity === "1") ||
        galleryItems[0];
      const nextItem = galleryItems[nextIndex];
      if (!nextItem || nextItem === currentItem) return;
      const direction = this.gallery_direction || 1;
      this.gallery_animating = !0;
      this.gallery_index = nextIndex;
      this.selectors.default_alter &&
        (this.selectors.default_alter.style.opacity = "0");
      this.selectors.gallery_images.forEach((item) => {
        if (item !== currentItem && item !== nextItem) {
          item.style.opacity = "0";
          item.style.transform = "";
          item.style.transition = "";
          item.style.zIndex = "";
        }
      });
      currentItem.style.opacity = "1";
      currentItem.style.transform = "translateX(0)";
      currentItem.style.transition = "none";
      currentItem.style.zIndex = "1";
      nextItem.style.opacity = "1";
      nextItem.style.transform = `translateX(${direction * 100}%)`;
      nextItem.style.transition = "none";
      nextItem.style.zIndex = "2";
      nextItem.offsetHeight;
      currentItem.style.transition = "transform .42s ease";
      nextItem.style.transition = "transform .42s ease";
      currentItem.style.transform = `translateX(${direction * -100}%)`;
      nextItem.style.transform = "translateX(0)";
      this.classList.add("product-card--gallery-active");
      this.updateGalleryControls();
      setTimeout(() => {
        currentItem.style.transition = "none";
        currentItem.style.opacity = "0";
        currentItem.offsetHeight;
        currentItem.style.zIndex = "";
        requestAnimationFrame(() => {
          currentItem.style.transform = "";
          currentItem.style.transition = "";
        });
        nextItem.style.opacity = "1";
        nextItem.style.transition = "none";
        nextItem.style.transform = "";
        nextItem.style.zIndex = "";
        this.gallery_animating = !1;
      }, 430);
    }
    moveGallery(direction) {
      const items = this.getActiveGalleryItems();
      if (items.length < 2) return;
      const visibleIndex = items.findIndex((item) => item.style.opacity === "1");
      this.gallery_index = visibleIndex > -1 ? visibleIndex : this.gallery_index;
      this.gallery_direction = direction;
      this.setGalleryIndex(this.gallery_index + direction, items);
    }
    updateGalleryControls() {
      if (!this.isListingGalleryEnabled()) {
        this.classList.remove("product-card--gallery-ready");
        [this.selectors.gallery_prev, this.selectors.gallery_next].forEach(
          (button) => {
            if (!button) return;
            button.hidden = true;
          },
        );
        return;
      }
      const hasGallery = this.getActiveGalleryItems().length > 1;
      this.classList.toggle("product-card--gallery-ready", hasGallery);
      [this.selectors.gallery_prev, this.selectors.gallery_next].forEach(
        (button) => {
          if (!button) return;
          button.hidden = !hasGallery;
        },
      );
    }
    initGalleryControls() {
      if (!this.selectors.gallery_prev || !this.selectors.gallery_next) return;
      [
        [this.selectors.gallery_prev, -1],
        [this.selectors.gallery_next, 1],
      ].forEach(([button, direction]) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (this.gallery_animating) return;
          this.gallery_user_interacted = !0;
          this.moveGallery(direction);
        });
      });
      this.updateGalleryControls();
      this.initMobileGallerySwipe();
      this.initDesktopGallerySwipe();
      this.playMobileGalleryHint();
    }
    initMobileGallerySwipe() {
      if (!this.selectors.media_link) return;
      this.selectors.media_link.addEventListener(
        "click",
        (event) => {
          if (!this.gallery_suppress_click) return;
          event.preventDefault();
          event.stopPropagation();
          this.gallery_suppress_click = !1;
        },
        true,
      );
      this.selectors.media_link.addEventListener(
        "touchstart",
        (event) => {
          if (!this.isMobileGallery()) return;
          const touch = event.touches[0];
          this.gallery_touch_start = {
            x: touch.clientX,
            y: touch.clientY,
          };
        },
        { passive: true },
      );
      this.selectors.media_link.addEventListener(
        "touchend",
        (event) => {
          if (
            !this.gallery_touch_start ||
            !this.isMobileGallery()
          )
            return;
          const touch = event.changedTouches[0];
          const diffX = touch.clientX - this.gallery_touch_start.x;
          const diffY = touch.clientY - this.gallery_touch_start.y;
          this.gallery_touch_start = null;
          if (Math.abs(diffX) < 35 || Math.abs(diffX) < Math.abs(diffY)) return;
          event.preventDefault();
          this.gallery_user_interacted = !0;
          this.gallery_suppress_click = !0;
          this.moveGallery(diffX < 0 ? 1 : -1);
        },
        { passive: false },
      );
    }
    initDesktopGallerySwipe() {
      if (!this.selectors.media_link) return;
      this.selectors.media_link
        .querySelectorAll("img")
        .forEach((image) => image.setAttribute("draggable", "false"));
      this.selectors.media_link.addEventListener("dragstart", (event) => {
        event.preventDefault();
      });
      this.selectors.media_link.addEventListener("pointerdown", (event) => {
        if (event.pointerType === "touch") return;
        if (event.button !== 0) return;
        if (this.getActiveGalleryItems().length < 2) return;
        this.gallery_pointer_start = {
          x: event.clientX,
          y: event.clientY,
          pointerId: event.pointerId,
        };
        try {
          this.selectors.media_link.setPointerCapture(event.pointerId);
        } catch (error) {}
        this.classList.add("product-card--gallery-dragging");
      });
      this.selectors.media_link.addEventListener("pointerup", (event) => {
        if (
          !this.gallery_pointer_start ||
          this.gallery_pointer_start.pointerId !== event.pointerId
        )
          return;
        const diffX = event.clientX - this.gallery_pointer_start.x;
        const diffY = event.clientY - this.gallery_pointer_start.y;
        this.gallery_pointer_start = null;
        try {
          this.selectors.media_link.releasePointerCapture(event.pointerId);
        } catch (error) {}
        this.classList.remove("product-card--gallery-dragging");
        if (Math.abs(diffX) < 35 || Math.abs(diffX) < Math.abs(diffY)) return;
        event.preventDefault();
        this.gallery_user_interacted = !0;
        this.gallery_suppress_click = !0;
        this.moveGallery(diffX < 0 ? 1 : -1);
      });
      ["pointercancel", "lostpointercapture"].forEach((eventName) => {
        this.selectors.media_link.addEventListener(eventName, () => {
          this.gallery_pointer_start = null;
          this.classList.remove("product-card--gallery-dragging");
        });
      });
    }
    playMobileGalleryHint() {
      if (
        window.productCardMobileGalleryHintPlayed ||
        !this.isFirstListingProductCard() ||
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      )
        return;
      const run = () => {
        if (window.productCardMobileGalleryHintPlayed) return;
        if (this.gallery_user_interacted) return;
        const items = this.getActiveGalleryItems();
        if (items.length < 2) return;
        setTimeout(() => {
          if (window.productCardMobileGalleryHintPlayed) return;
          if (this.gallery_user_interacted) return;
          const current =
            items.find((item) => item.style.opacity === "1") || items[0];
          const preview = items.find((item) => item !== current);
          if (!current || !preview) return;
          window.productCardMobileGalleryHintPlayed = true;
          this.classList.add("product-card--gallery-hinting");
          current.classList.add("product-card__gallery-hint-current");
          preview.classList.add("product-card__gallery-preview");
          current.offsetHeight;
          preview.offsetHeight;
          requestAnimationFrame(() => {
            current.classList.add(
              "product-card__gallery-hint-current--armed",
              "product-card__gallery-hint-current--visible",
            );
            preview.classList.add(
              "product-card__gallery-preview--armed",
              "product-card__gallery-preview--visible",
            );
            setTimeout(() => {
              current.classList.remove("product-card__gallery-hint-current--visible");
              preview.classList.remove("product-card__gallery-preview--visible");
              setTimeout(() => {
                preview.classList.add("product-card__gallery-preview--ending");
                preview.offsetHeight;
                current.classList.remove(
                  "product-card__gallery-hint-current",
                  "product-card__gallery-hint-current--armed",
                );
                preview.classList.remove(
                  "product-card__gallery-preview",
                  "product-card__gallery-preview--armed",
                  "product-card__gallery-preview--ending",
                );
                this.classList.remove("product-card--gallery-hinting");
              }, 450);
            }, 650);
          });
        }, 650);
      };
      if (!("IntersectionObserver" in window)) {
        run();
        return;
      }
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            run();
          });
        },
        { threshold: 0.55 },
      );
      observer.observe(this);
    }
    initSwatches() {
      if (!this.variant_filter_active && !this.initial_option_value) return;
      this.applyVariantImage();
      setTimeout(() => this.applyVariantImage(), 0);
    }
  }
  customElements.define("product-card", a);
}
